module.exports = "/virtual-football-league/img/video/clubs/spain/atletico-bilbao.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/spain/atletico-bilbao.png
// module id = 353
// module chunks = 4